import React from 'react';
import AssessmentTool from './AssessmentTool';
import { maturityQuestions, maturityMeta, computeMaturityResult } from '../config/securityMaturityConfig';

const SecurityMaturityPage = () => (
  <AssessmentTool
    meta={maturityMeta}
    questions={maturityQuestions}
    computeResult={computeMaturityResult}
  />
);

export default SecurityMaturityPage;
